import { Click, ClickType, ElementType, Impression } from '@fiverr-private/bianka_js';
import { bianka } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { PAGE_NAME } from '../../events';

export const reportHourlyCardClick = () => {
    const { pageCtxId, userId, organizationId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: 'clicked_request_an_hourly_offer_gig_page',
            clickType: ClickType.LEFT,
            user: {
                id: userId as number,
            },
            element: {
                name: 'request_an_hourly_offer',
                type: ElementType.BUTTON,
                numberOfElements: 1,
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
            organization: {
                id: organizationId as string,
            },
        },
    });
};

export const reportHourlyCardImpression = () => {
    const { pageCtxId, userId, organizationId } = getContext();

    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: 'viewed_request_an_hourly_offer_gig_page',
            user: {
                id: userId as number,
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
            organization: {
                id: organizationId as string,
            },
        },
    });
};

export const reportAISummaryImpression = (params: { gigId: number; sellerId: number }) => {
    const { pageCtxId, userId } = getContext();
    const { gigId, sellerId } = params;

    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: 'viewed_ai_summary',
            component: {
                impId: Date.now().toString(),
                name: 'summary_viewed',
                type: 'card',
                level: 0,
                sizeInParent: 0,
                positionInParent: 0,
                isLeaf: false,
                visibleThroughScroll: false,
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
            user: {
                id: userId as number,
            },
            gig: {
                id: gigId,
            },
            seller: {
                id: sellerId,
            },
        },
    });
};

export const reportAISummaryToggle = (params: { expanded: boolean; gigId: number; sellerId: number }) => {
    const { pageCtxId, userId } = getContext();
    const { expanded, gigId, sellerId } = params;

    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: 'clicked_on_ai_summary',
            clickType: ClickType.LEFT,
            element: {
                name: `${expanded ? 'unfold' : 'fold'}_summary`,
                type: ElementType.UNSPECIFIED,
                text: {
                    value: `Arrow ${expanded ? 'down' : 'up'}`,
                },
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
            user: {
                id: userId as number,
            },
            gig: {
                id: gigId,
            },
            seller: {
                id: sellerId,
            },
        },
    });
};
